import { useModal } from "../context/ModalContext";
import { FiX, FiChevronRight } from "react-icons/fi";
import hoverShape from "../assets/images/icon/hov_shape_L.svg";
import GoogleIcon from "../assets/images/icon/dsc.png";
import overlayimg from "../assets/images/modal_overlay.png";

const SignUpModal = () => {
  const { SignUpModalHandle, connectWalletHandle } = useModal();
  return (
    <>
      <div className="modal_box ">
        <div className="">
          <div className="mint_modal_box bg-primary  p-10 relative w-[440px] mx-auto  flex justify-center ">
            <div
              style={{
                backgroundImage: `url(${overlayimg})`,
              }}
              className="mint_modal_content "
            >
              <div className="modal_header mb-5">
                <h2 className="text-center text-white text-2xl">
                  Sign Up
                </h2>
                <button
                  className="float-right"
                  onClick={() => SignUpModalHandle()}
                >
                  <FiX color="white" className="absolute top-3 right-3" />
                </button>
              </div>
              <div className="modal_body text-center text-white flex justify-center flex-col items-center ">
                <p className="mb-7">
                  Signup on our official chapter
                </p>
               
               <a href="https://gdsc.community.dev/usman-institute-of-technology/" className="wallet_list text-white space-y-6 w-full " target="__blank" onClick={() => SignUpModalHandle()}
> <div className="wallet_list text-white space-y-6 w-full ">
                  <button
                    className="WalletButtons cursor-pointer"
                  >
                    <img src={GoogleIcon} alt="Google-Developer" />
                    GDSC UIT
                    <span className="absolute right-3">
                      <FiChevronRight />
                    </span>
                  </button>
                 
                </div>
                </a>

                <div className="modal_bottom_text mt-5">
                  Please Signup to stay updated, of our
                  <a href=""> Events </a>
                  <a href="">And workshops</a>
                </div>
              </div>

              <div className="modal_bottom_shape_wrap">
                <span className="absolute left-3 bottom-3 rotate_x ">
                  <img src={hoverShape} alt="hover shape" />
                </span>
                <span className="absolute right-3 bottom-3  rotate_y ">
                  <img src={hoverShape} alt="hover shape" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpModal;
